import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, Label, Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap';
import mfgFetch from "./mfg-fetch";

class AdminApprovals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: {
                approvedContent: [],
                approvalContent: [],
                rejectedContent: [],
            },
            approvalLogos: [],
            approvalBlurbs: [],
            selectedContent: null,
            submitFailed: false,
            approvalModalState: false,
            denyModalState: false,
            denialReason: "",
            denyContent: "content",
            denyPrefId: "",
        };

        this.handleContent = this.handleContent.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleDeny = this.toggleDeny.bind(this);
        this.approvePreference = this.approvePreference.bind(this);
    }

    componentWillMount() {
    }


    componentDidMount() {
        this.grabContent();
        this.grabPreferences();
    }

    grabPreferences() {
        mfgFetch('/api/v1/mfg/preferences', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.handlePreferences(body);
            })
            .catch((err) => {
                console.error("Could not get preferences", err);
            });

        if (this.state.denyModalState) {
            this.setState({
                denyModalState: false,
            });
        }
    }

    grabContent() {
        mfgFetch('/api/v1/mfg/content', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.handleContent(body);
            })
            .catch((err) => {
                console.error("Could not get content", err);
            });

        if (this.state.denyModalState || this.state.approvalModalState) {
            this.setState({
               approvalModalState: false,
               denyModalState: false,
            });
        }
    }

    handleContent(contents) {
        let approvedContent = [];
        let approvalContent = [];
        let rejectedContent = [];
        if (contents) {
            for (let content of contents) {
                if (content.hasOwnProperty('content_approved')) {
                    switch (content.content_approved) {
                        case "0":
                            approvalContent.push(content);
                            break;
                        case "1":
                            approvedContent.push(content);
                            break;
                        case "-1":
                            rejectedContent.push(content);
                            break;
                        default:
                            console.log("invalid content approval status");
                            break;
                    }
                }
            }
        }

        this.setState({
            content: {
                approvedContent: approvedContent,
                approvalContent: approvalContent,
                rejectedContent: rejectedContent,
            }
        });
    }

    handlePreferences(prefs) {
        if (!prefs) {
            return;
        }

        let approvalLogos = [];
        let approvalBlurbs = [];
        for (let pref of prefs) {
            if (pref.hasOwnProperty("preferences_temp_logo")) {
                if (pref.preferences_temp_logo !== "") {
                    approvalLogos.push(pref);
                }
            }
            if (pref.hasOwnProperty("preferences_temp_blurb")) {
                if (pref.preferences_temp_blurb !== "") {
                    approvalBlurbs.push(pref);
                }
            }
        }

        this.setState({
            approvalLogos: approvalLogos,
            approvalBlurbs: approvalBlurbs,
        });
    }

    toggle() { // toggle open content window
        this.setState(prevState => ({
            approvalModalState: !prevState.approvalModalState
        }));
    }

    toggleDeny(e, denyId, denyContent) {
        this.setState(prevState => ({
            denyModalState: !prevState.denyModalState
        }));
        this.setState({
            denyPrefId: denyId,
            denyContent: denyContent,
        });
    }

    selectContent(content) {
        this.setState({
            approvalModalState: true,
            selectedContent: content,
        });
    }

    updateDenialReason(e) {
        this.setState({
            denialReason: e.target.value
        });
    }

    approveContent(id, status) {
        if (status === "0" && this.state.denialReason === "") {
            this.setState({
                submitFailed: true,
            });
            return;
        }
        mfgFetch('/api/v1/mfg/approval', {
            method: 'POST',
            body: JSON.stringify({
                content_id: id,
                content_approved: status,
                content_denial: this.state.denialReason
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.grabContent();
            })
            .catch((err) => {
                console.error('could not approve content: ', err);
                this.setState({
                    submitFailed: true
                });
                this.grabContent();
            });
    }

    approvePreference(manufacturer, type, status) {
        mfgFetch('/api/v1/mfg/preferences-approval', {
            method: 'POST',
            body: JSON.stringify({
                preference_manufacturer: manufacturer,
                preference_type: type,
                preference_approved: status,
                preference_denial: this.state.denialReason,
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.grabPreferences();
            })
            .catch((err) => {
                console.error('could not approve content: ', err);
            });
    }

    render() {
        let approvalContent = [];
        let contentPending = "";
        for (let content of this.state.content.approvalContent) {

            let viewDetails = (
                <Button className="flex-fill approval-view-button" color="primary" onClick={(e) => this.selectContent(content)}>View Details</Button>
            );

            let lastUpdated = new Date(content.content_updated);
            let daysPending = (((new Date()).getTime() -  lastUpdated.getTime()) / 86400000);
            let hoursPending = Math.floor((daysPending % 1) * 24);
            let daysText = 'day';
            if (daysPending >= 2) {
                daysText = 'days';
            }
            let hoursText = 'hour';
            if (hoursPending >= 2) {
                hoursText = 'hours';
            }

            if (daysPending >= 1) {
                contentPending = (
                    <p>Pending for {daysPending.toFixed(0)} {daysText} and {hoursPending} {hoursText}</p>
                );
            } else if (hoursPending >= 1) {
                contentPending = (
                    <p>Pending for {hoursPending} {hoursText}</p>
                );
            } else {
                contentPending = (
                    <p>Pending for less than an hour</p>
                );
            }

            approvalContent.push(
                <Card>
                    <CardBody className="mfg-content-card">
                        <CardTitle><b>{content.content_title}</b></CardTitle>
                        <CardSubtitle>Awaiting approval</CardSubtitle>
                        <br />
                        <CardText>
                            {contentPending}
                        </CardText>
                        <div className="d-flex flex-column p-1">
                            <span className="d-flex flex-row justify-content-between p-1">
                                {viewDetails}
                            </span>
                        </div>
                    </CardBody>
                </Card>
            );
        }

        let logoApprovals = [];
        for (let pref of this.state.approvalLogos) {
            logoApprovals.push(
                <Card>
                    <CardBody className="mfg-content-card">
                        <CardTitle><b>New Logo</b></CardTitle>
                        <CardSubtitle>Awaiting approval</CardSubtitle>
                        <br />
                        <CardText>
                            <img src={pref.preferences_temp_logo} />
                        </CardText>
                        <div className="d-flex flex-column p-1">
                            <span className="d-flex flex-row justify-content-between p-1">
                                Manufacturer: {pref.preferences_manufacturer_text}
                            </span>
                        </div>
                        <div className="d-flex flex-row justify-content-around">
                            <Button color="primary" className="align-self-center" onClick={(e) => this.approvePreference(pref.preferences_manufacturer, "logo", "1")}>Approve</Button>
                            <Button className="align-self-center" onClick={(e) => this.toggleDeny(e, pref.preferences_manufacturer, "logo")}>Deny</Button>
                        </div>
                    </CardBody>
                </Card>
            );
        }

        let blurbApprovals = [];
        for (let pref of this.state.approvalBlurbs) {
            let oldSlogan = null;
            if (pref.preferences_blurb !== "") {
                oldSlogan = (
                    <p>Old Slogan: {pref.preferences_blurb}</p>
                );
            }
            blurbApprovals.push(
                <Card>
                    <CardBody className="mfg-content-card">
                        <CardTitle><b>New Slogan</b></CardTitle>
                        <CardSubtitle>Awaiting approval</CardSubtitle>
                        <br />
                        <CardText>
                            New slogan: {pref.preferences_temp_blurb}
                            {oldSlogan}
                        </CardText>
                        <div className="d-flex flex-column p-1">
                            <span className="d-flex flex-row justify-content-between p-1">
                                Manufacturer: {pref.preferences_manufacturer_text}
                            </span>
                        </div>
                        <div className="d-flex flex-row justify-content-around">
                            <Button color="primary" className="align-self-center" onClick={(e) => this.approvePreference(pref.preferences_manufacturer, "blurb", "1")}>Approve</Button>
                            <Button className="align-self-center" onClick={(e) => this.toggleDeny(e, pref.preferences_manufacturer, "blurb")}>Deny</Button>
                        </div>
                    </CardBody>
                </Card>
            );
        }

        let approvalSection = (
            <div className="d-flex flex-column py-2">
                <h3 className="section-title">Awaiting Approval</h3>
                <div className="d-flex flex-row">
                    {approvalContent}
                </div>
                <div className="d-flex flex-row">
                    {logoApprovals}
                </div>
                <div className="d-flex flex-row">
                    {blurbApprovals}
                </div>
            </div>
        );

        let modal = '';
        let denyModal = '';
        if (this.state.denyContent !== "") {
            let denyButton = "";
            switch (this.state.denyContent) {
                case "content":
                    denyButton = (
                        <Button className="mx-auto" onClick={(e) => this.approveContent(this.state.selectedContent.content_id, "-1")}>Deny Content</Button>
                    );
                    break;

                case "logo":
                    denyButton = (
                        <Button className="mx-auto" onClick={(e) => this.approvePreference(this.state.denyPrefId, "logo", "-1")}>Deny Logo</Button>
                    );
                    break;

                case "blurb":
                    denyButton = (
                        <Button className="mx-auto" onClick={(e) => this.approvePreference(this.state.denyPrefId, "blurb", "-1")}>Deny Slogan</Button>
                    );
                    break;
            }

            denyModal = (
                <Modal isOpen={this.state.denyModalState}>
                    <ModalBody>
                        <ModalHeader>Deny Content</ModalHeader>
                        <div className="d-flex flex-column">
                            <p>
                                Are you sure you want to deny this uploaded {this.state.denyContent} ? You must give a denial reason below which the manufacturer will be able to view.
                            </p>
                            <span className="deny-reason align-self-center pb-4">
                                <textarea name="content_denial" className="deny-textarea" rows="4" onChange={e => this.updateDenialReason(e)} required />
                            </span>
                            <span className="d-flex flex-row justify-content-between">
                                {denyButton}
                                <Button className="mx-auto" onClick={(e) => this.toggleDeny(e, "-1", "content")}>Cancel</Button>
                            </span>
                        </div>
                    </ModalBody>
                </Modal>
            );
        }


        if (this.state.selectedContent) {
            let uploaded = new Date(this.state.selectedContent.content_uploaded);
            let lastUpdated = new Date(this.state.selectedContent.content_updated);
            let locale = window.navigator.userLanguage || window.navigator.language || "en-US";
            let start = "";
            if (this.state.selectedContent.content_range_start) {
                start = (
                    <span><b>Start:</b> {new Date(this.state.selectedContent.content_range_start).toLocaleDateString(locale)}</span>
                );
            }
            let end = "";
            if (this.state.selectedContent.content_range_end) {
                end = (
                    <span><b>End:</b> {new Date(this.state.selectedContent.content_range_end).toLocaleDateString(locale)}</span>
                );
            }

            modal = (
                <span>
                    <ModalHeader toggle={this.toggle}>{this.state.selectedContent.content_title}</ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-row">
                                <span className="content-stats d-flex flex-column">
                                    <p><b>Description:</b> {this.state.selectedContent.content_description}</p>
                                    <p><b>Type:</b> {this.state.selectedContent.content_type}</p>
                                    <p><b>Category:</b> {this.state.selectedContent.content_category}</p>
                                    {start}
                                    {end}
                                    <hr/>
                                    <span><b>Manufacturer:</b> {this.state.selectedContent.content_manufacturer_text}</span>
                                    <span><b>Initial Uploaded:</b> {uploaded.toLocaleDateString("en-US")}</span>
                                    <span><b>Last Updated:</b> {lastUpdated.toLocaleDateString("en-US")}</span>
                                    <span>{contentPending}</span>
                                </span>
                                <span className="content-thumbnail justify-content-center my-auto">
                                    <span className="d-flex flex-column">
                                        <img src={"/content/" + this.state.selectedContent.content_id + "_t"} alt="Content thumbnail" className="mx-auto" />
                                        <a href={"/content/" + this.state.selectedContent.content_id} target="_blank" className="mx-auto pt-2">View Content</a>
                                    </span>
                                </span>
                            </div>
                            <span className="d-flex flex-row justify-content-between p-1">
                                <Button className="mx-auto" color="primary" onClick={(e) => this.approveContent(this.state.selectedContent.content_id, "1")}>Approve Content</Button>
                                <Button className="mx-auto" color="secondary" onClick={(e) => this.toggleDeny(e, "-1", "content")}>Deny Content</Button>
                            </span>
                        </div>
                    </ModalBody>
                </span>
            );
        }
        return (
            <div>
                <div className="d-flex flex-column">
                    {approvalSection}
                </div>

                <Modal isOpen={this.state.approvalModalState}>
                    {modal}
                </Modal>
                {denyModal}
            </div>
        );
    }
}

export default AdminApprovals;
